<script>
import { RemoveOldBasketAndCart, UniqueDiscountCode } from '~/lib/util/basket'
import { sendDotDigitalCartInsightEvent } from '~/lib/util/dotdigital'

const jwt = require('jwt-simple')

export default {
  data() {
    return {
      isLoading: false,
      showViewAndBuyButton: true
    }
  },
  created() {
    // // Tracking DotDigital Event itendity
    // this.$nuxt.$off('DOT_DIGITAL_TRACKING_IDENTIFY')
    // this.$nuxt.$on('DOT_DIGITAL_TRACKING_IDENTIFY', ({ email }) => {
    //   window && sendDotDigitalIdentifyEvent({ window, email })
    // })

    // Tracking DotDigital Event cartInsight
    this.$nuxt.$off('DOT_DIGITAL_TRACKING_CART_INSIGHT')
    this.$nuxt.$on('DOT_DIGITAL_TRACKING_CART_INSIGHT', ({ success, basket, action, error, cartPhase }) => {
      if (error) {
        console.info(`DOT_DIGITAL_TRACKING_CART_INSIGHT success=${success} action=${action} cartPhase=${cartPhase} error=`, error)
        return
      }

      console.info(`DOT_DIGITAL_TRACKING_CART_INSIGHT success=${success} action=${action} cartPhase=${cartPhase} basket=`, basket)
      let cartPhaseLabel = cartPhase || undefined
      if (action) {
        switch (action) {
          case 'add':
            cartPhaseLabel = 'ADD_TO_CART'
            break
          case 'remove':
            cartPhaseLabel = 'REMOVE_FROM_CART'
            break
          case 'delete':
            cartPhaseLabel = 'DELETE_FROM_CART'
            break
          case 'update':
            cartPhaseLabel = 'UPDATE_CART'
            break
        }
      }

      const abandonedBasket = basket?.abandoned_basket || this.setAbandonedBasket(basket) || undefined
      window && sendDotDigitalCartInsightEvent({ window, basket, cartPhase: cartPhaseLabel, AbandonedBasket: abandonedBasket })
    })
  },
  methods: {
    setAbandonedBasket(basket) {
      let AbandonedBasketUniqueCode = this.$store.getters['cart/AbandonedBasketUniqueCode']
      if (!this.$store.getters['cart/AbandonedBasketUniqueCode']) {
        AbandonedBasketUniqueCode = UniqueDiscountCode()
        this.$store.commit('cart/AbandonedBasketUniqueCode', AbandonedBasketUniqueCode)
      }

      const currentDate = new Date()
      // Add 30 days to the current date
      currentDate.setDate(currentDate.getDate() + 30)

      const ret = {
        // id: '1',
        code: AbandonedBasketUniqueCode,
        expiry_date: currentDate,
        expiry_date_formatted: new Date(currentDate).toLocaleDateString('en-GB')
      }

      console.log('setAbandonedBasket=', ret)
      return ret
    },

    getProductUrl(item) {
      // Custom redirect ALWAYS to the canonical url for a Pocketmags Plus product
      if (item.title === 'Pocketmags Plus+') {
        return item.url
      }
      if (this.categoryUrl) {
        const productPath = item.url.replace(/^\/magazines/, '')
        return `${this.categoryUrl}${productPath}`
      }
      return item.url.replace(/magazine-(\d{4,5})$/g, 'magazine')
    },

    getItemPayloadByProductType({ item, action, type, extras }) {
      if ((action === 'remove' || action === 'delete') && (type === 'GIFTCARD' || type === 'EGIFTCARD' || type === 'POCKETMAGSPLUS')) {
        return {
          id: item.id
        }
      }
      if (action === 'update' && (type === 'GIFTCARD' || type === 'EGIFTCARD')) {
        return {
          ...extras,
          id: item.id,
          product_sku: item.sku,
          offer_sku: item.offer.sku,
          qty: 1
        }
      }

      if (type === 'POCKETMAGSPLUS') {
        return {
          ...extras,
          offer: { ...item.offer },
          id: item.id,
          product_sku: item.sku,
          offer_sku: item.offer.sku,
          qty: 1
        }
      }
      return {
        ...extras,
        product_sku: item.sku,
        offer_sku: item.offer.sku,
        qty: (action === 'delete' && process.env.ITEM_MAX_QTY) || 1
      }
    },

    async updateBasket({ item, action, type, extras }) {
      console.log(`mixins/basket updateBasket action=${action} type=${type} basket_id=${this.$store.state.basket.id}`)
      console.log(`mixins/basket updateBasket item=`, item)

      // Used to fix the Cookies props between Nuxt and Vue3
      RemoveOldBasketAndCart(this)

      this.isLoading = true
      let basket
      let error
      // console.log(`updateBasket action=${action} offer.productId=${item.offer.productId} offer.productCartId=${item.offer.productCartId}`)
      let ret = null
      if (this.$nuxt.$config.MongoDBIntegration) {
        // MONGODB Integration
        console.info(`MONGODB updateBasket action=${action} type=${type} product_id=${item.id} product_sku=${item.sku} offer_sku=${item.offer.sku}`)
        extras && console.info(`MONGODB updateBasket extras=`, extras)
        ret = await this.$store.dispatch('UPDATE_BASKET_MONGODB', {
          id: this.$store.state.basket.id,
          action,
          item,
          type,
          request: {
            action,
            type,
            affiliateURL: this.$store.getters['s/affiliateURL'] || null,
            item: {
              ...this.getItemPayloadByProductType({ item, action, type, extras })
            }
          }
        })

        if (ret.error) {
          // Error, show an overlay on the page
          error = ret.error
          this.$nuxt.$emit('SHOW_NOTIFICATION', { data: ret.error, show: true })
        } else if (!this.$cookies.get('cart')) {
          this.$cookies.set('cart', jwt.encode({ cartId: this.$store.state.basket.id }, process.env.JWT_SECRET), {
            path: '/',
            maxAge: 3600 * 24 * 30,
            domain: process.env.BACKEND_COOKIES_DOMAIN,
            secure: process.env.NODE_ENV === 'production'
          })
          basket = ret
        } else {
          basket = ret
        }
        basket && this.$nuxt.$emit('BASKET_READY', { ready: true, basket })
        basket
          ? this.$nuxt.$emit('DOT_DIGITAL_TRACKING_CART_INSIGHT', { success: true, basket, action })
          : this.$nuxt.$emit('DOT_DIGITAL_TRACKING_CART_INSIGHT', { success: false, action, error })
      } else {
        // MAGENTO Integration
        ret = await this.$store.dispatch('UPDATE_CART', {
          cartId: this.$store.state.basket.id,
          productId: item.offer.productId,
          action,
          item
        })
        if (ret.error) {
          // Error, show an overlay on the page
          this.$nuxt.$emit('SHOW_NOTIFICATION', { data: ret.error, show: true })
        } else if (!this.$cookies.get('cart')) {
          this.$cookies.set('cart', jwt.encode({ cartId: this.$store.state.basket.id }, process.env.JWT_SECRET), {
            path: '/',
            maxAge: 3600 * 24 * 30,
            domain: process.env.BACKEND_COOKIES_DOMAIN,
            secure: process.env.NODE_ENV === 'production'
          })
          this.$nuxt.$emit('BASKET_READY', { ready: true, basket: ret })
        }
      }
      this.isLoading = false
      return ret
    }
  }
}
</script>
